"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _lodash = require("lodash");

require("react-dates/initialize");

require("react-dates/lib/css/_datepicker.css");

var _reactDates = require("react-dates");

var _utils = require("../../utils");

var _DateRangePickerWrapper = _interopRequireDefault(require("./DateRangePickerWrapper"));

var _ButtonPanel = _interopRequireDefault(require("./ButtonPanel"));

var _excluded = ["interval", "onSelectInterval"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var START_DATE = 'startDate';
var END_DATE = 'endDate';
var HORIZONTAL_ORIENTATION = 'horizontal';

var DateRangePickerController = function DateRangePickerController(_ref) {
  var interval = _ref.interval,
      onSelectInterval = _ref.onSelectInterval,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = interval || {},
      propStartDate = _ref2.startDate,
      propEndDate = _ref2.endDate;

  var defaultStartDate = _utils.defaultMomentObjInterval.startDate,
      defaultEndDate = _utils.defaultMomentObjInterval.endDate;
  var defaultStartState = propStartDate ? (0, _moment.default)(propStartDate) : defaultStartDate;
  var defaultEndState = propEndDate ? (0, _moment.default)(propEndDate) : defaultEndDate;

  var _useState = (0, _react.useState)(defaultStartState),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultEndState),
      _useState4 = _slicedToArray(_useState3, 2),
      endDate = _useState4[0],
      setEndDate = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      focusedInput = _useState6[0],
      setFocusedInput = _useState6[1];

  (0, _react.useEffect)(function () {
    if (interval) {
      var _startDate = interval.startDate,
          _endDate = interval.endDate; //receive UTC string

      onDatesChange({
        startDate: (0, _moment.default)(_startDate),
        endDate: (0, _moment.default)(_endDate)
      });
    }
  }, [interval]);

  var onDatesChange = function onDatesChange(_ref3) {
    var newStartDate = _ref3.startDate,
        newEndDate = _ref3.endDate;
    newEndDate = newEndDate || endDate;

    if (newEndDate.isBefore(newStartDate)) {
      var tempStart = newStartDate.clone();
      newStartDate = newEndDate.clone();
      newEndDate = tempStart;
    }

    var sameStart = _moment.default.isMoment(newStartDate) && newStartDate.isSame(startDate, 'day');
    var sameEnd = _moment.default.isMoment(newEndDate) && newEndDate.isSame(endDate, 'day');

    if (sameStart && !sameEnd) {
      setEndDate(newEndDate);
    } else if (!startDate && sameEnd) {
      setStartDate(newStartDate);
    } else {
      setStartDate(newStartDate);
      setEndDate(newEndDate);
    }
  };

  var onFocusChange = function onFocusChange(focusedInput) {
    if (!focusedInput) {
      onCancel();
    } else {
      setFocusedInput(focusedInput);
    }
  };

  var onUpdate = function onUpdate() {
    if (startDate && endDate && onSelectInterval) {
      var startOfDay = startDate.clone().startOf('day').toISOString();
      var endOfDay = endDate.clone().endOf('day').toISOString();
      onSelectInterval({
        startDate: startOfDay,
        endDate: endOfDay
      });
    }

    setFocusedInput(null);
  };

  var onCancel = function onCancel() {
    setStartDate(defaultStartState);
    setEndDate(defaultEndState);
    setFocusedInput(null);
  };

  var onPresetClick = function onPresetClick(_ref4) {
    var amount = _ref4.amount,
        label = _ref4.label,
        unit = _ref4.unit;
    var endDate = (0, _moment.default)();
    var startDate = label === "Last Year" || label === "Last 2 Years" ? (0, _moment.default)().subtract(amount, unit) : (0, _moment.default)().startOf(unit).subtract(amount - 1, unit);
    setStartDate(startDate);
    setEndDate(endDate);
  };

  var isPresetActive = function isPresetActive(_ref5) {
    var amount = _ref5.amount,
        label = _ref5.label,
        unit = _ref5.unit;
    if (!startDate || !endDate) return false;
    var presetEndDate = (0, _moment.default)();
    var presetStartDate = label === "Last Year" || label === "Last 2 Years" ? (0, _moment.default)().subtract(amount, unit) : (0, _moment.default)().startOf(unit).subtract(amount - 1, unit);
    return endDate.isSame(presetEndDate, 'day') && startDate.isSame(presetStartDate, 'day');
  };

  var componentProps = (0, _lodash.omit)(props, ['interval', 'onSelectInterval']);
  return /*#__PURE__*/_react.default.createElement(_DateRangePickerWrapper.default, null, /*#__PURE__*/_react.default.createElement(_reactDates.DateRangePicker, _extends({}, componentProps, {
    startDate: startDate,
    endDate: endDate,
    focusedInput: focusedInput,
    minimumNights: 0,
    onDatesChange: onDatesChange,
    onFocusChange: onFocusChange,
    renderCalendarInfo: function renderCalendarInfo() {
      return /*#__PURE__*/_react.default.createElement(_ButtonPanel.default, {
        onUpdate: onUpdate,
        onCancel: onCancel,
        onPresetClick: onPresetClick,
        checkPresetActive: isPresetActive
      });
    }
  })));
};

var defaultProps = {
  //configuration props
  startDateOffset: undefined,
  endDateOffset: undefined,
  startDateId: START_DATE,
  startDatePlaceholderText: 'Start Date',
  endDateId: END_DATE,
  endDatePlaceholderText: 'End Date',
  minDate: null,
  maxDate: null,
  showDefaultInputIcon: false,
  customInputIcon: null,
  customArrowIcon: 'to',
  customCloseIcon: null,
  noBorder: true,
  readOnly: true,
  // day presentation and interaction related props
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _reactDates.isInclusivelyBeforeDay)(day, (0, _moment.default)());
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  hideKeyboardShortcutsPanel: true,
  anchorDirection: 'right',
  enableOutsideDays: false,
  // calendar presentation and interaction related props
  orientation: HORIZONTAL_ORIENTATION,
  verticalHeight: undefined,
  initialVisibleMonth: function initialVisibleMonth() {
    return (0, _moment.default)().subtract(1, 'month');
  },
  numberOfMonths: 2,
  keepOpenOnDateSelect: true,
  renderCalendarInfo: null,
  isRTL: false,
  // navigation related props
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  // internationalization
  displayFormat: function displayFormat() {
    return _moment.default.localeData().longDateFormat('L');
  },
  monthFormat: 'MMMM YYYY'
};
DateRangePickerController.propTypes = {
  interval: _propTypes.default.shape({
    startDate: _propTypes.default.string,
    endDate: _propTypes.default.string
  }),
  onSelectInterval: _propTypes.default.func.isRequired
};
DateRangePickerController.defaultProps = defaultProps;
var _default = DateRangePickerController;
exports.default = _default;